var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#636799"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4934_247501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9972 13.4484C26.9874 13.349 26.9487 13.2492 26.8807 13.1662C26.8544 13.1341 27.123 13.4048 22.8727 9.15447C22.7714 9.05316 22.6338 8.99996 22.4996 9C22.1798 9 10.9006 9 10.582 9C9.70969 9 9 9.70969 9 10.582V25.4177C9 26.29 9.70969 26.9997 10.582 26.9997H25.4177C26.29 26.9997 26.9997 26.29 26.9997 25.4177C26.9998 12.6145 27.0012 13.4888 26.9972 13.4484ZM21.1288 10.0547V13.4999C21.1288 13.7907 20.8922 14.0273 20.6014 14.0273H19.9335V10.0547H21.1288ZM18.8788 10.0547V14.0273H13.9921C13.7014 14.0273 13.4648 13.7907 13.4648 13.4999V10.0547H18.8788ZM21.1288 20.285H13.4648V19.617C13.4648 19.3263 13.7014 19.0897 13.9921 19.0897H20.6014C20.8922 19.0897 21.1288 19.3263 21.1288 19.617V20.285ZM13.4648 25.9451V21.3397H21.1288V25.9451H13.4648ZM25.9451 25.4177C25.9451 25.7085 25.7085 25.9451 25.4178 25.9451H22.1834C22.1834 25.2576 22.1834 20.4007 22.1834 19.617C22.1834 18.7447 21.4737 18.035 20.6014 18.035H13.9921C13.1198 18.035 12.4101 18.7447 12.4101 19.617V25.9451H10.582C10.2913 25.9451 10.0547 25.7085 10.0547 25.4177V10.582C10.0547 10.2912 10.2913 10.0547 10.582 10.0547H12.4101V13.4999C12.4101 14.3723 13.1198 15.0819 13.9921 15.0819H20.6014C21.4737 15.0819 22.1834 14.3723 22.1834 13.4999V10.0547H22.2814L25.9451 13.7184V25.4177Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4934_247501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveNew);
export default __webpack_public_path__ + "static/media/saveNew.e013c26a.svg";
export { ForwardRef as ReactComponent };